import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';

import { ButtonComponent } from '@core/user-interface-legacy';

import { ThemeService } from './services/theme.service';

@Component({
  selector: 'app-root',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterOutlet, RouterLink, RouterLinkActive, ButtonComponent],
  template: `
    <header>
      <h1>Dynamic Stagings</h1>
      <nav>
        <a routerLink="/" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"
          >Branches</a
        >
        <a routerLink="/environments" routerLinkActive="active">Environments</a>
      </nav>
      <rt-button
        class="theme-toggle"
        variant="tertiary"
        size="small"
        (click)="themeService.toggleTheme()"
      >
        {{ themeService.isDarkMode() ? 'Light' : 'Dark' }}
      </rt-button>
    </header>
    <main>
      <router-outlet />
    </main>
  `,
  styleUrl: './app.component.less',
})
export class AppComponent {
  protected readonly themeService = inject(ThemeService);
}
